/** Firebase words its verification and reset mails in `languageCode`: the portal's language. */
export function setMailLanguage(auth: { languageCode: string | null }, locale: string): void {
	auth.languageCode = locale;
}
